import { useMemo } from 'react';
import { Link as RouterLink, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Link } from 'bonfire-kindling';

const SavedSearchListItem = ({ id, name, onDelete }) => {
  const { t } = useTranslation();
  const elementId = useMemo(() => `${id}-opportunities-saved-search`, [id]);

  return (
    <Box component="li" sx={{ display: 'inline-flex', alignItems: 'center', px: 3 }}>
      <Link
        id={elementId}
        component={NavLink}
        sx={{ mr: 'auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        to={`/opportunities/saved/${id}`}
        target="_self"
        activeStyle={{ fontWeight: 'bold' }}
        rel={undefined}
      >
        {name}
      </Link>
      <IconButton
        component={RouterLink}
        iconName="pencil-alt"
        variant="text"
        aria-label={t('opportunities.filters.saved_search_edit')}
        aria-describedby={elementId}
        size="small"
        to={`/settings/saved/${id}/edit`}
        borderless
      />
      <IconButton
        iconName="trash"
        onClick={onDelete}
        aria-label={t('opportunities.filters.saved_search_delete')}
        aria-describedby={elementId}
        size="small"
        borderless
      />
    </Box>
  );
};

export default SavedSearchListItem;
